import { useEffect, useContext } from "react";
import { useDispatch } from "react-redux";

import LoginCard from "components/LoginCard";
import Billboard from "components/General/Billboard";
import GuestServicesCard from "components/GuestServicesCard";
import AgentSignupCard from "components/AgentPortal/AgentSignupCard";

import { useBreadcrumb } from "hooks/useBreadcrumb";

import { removeUser } from "redux/slices/userSlice";
import { removeCsrUser } from "redux/slices/csrUserSlice";
import { useTranslation, Trans } from "react-i18next";
import { AgentData } from "context/Agent/DataProvider";

export default function LandingEVL({
  portal,
  setHideCustomChat,
  connectingToSF,
  setConnectingToSF,
  openChatWindow,
  setOpenChatWindow,
  bannerMessage,
  bannerTitle,
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { setAgentData } = useContext(AgentData);
  useBreadcrumb([]);
  useEffect(() => {
    dispatch(removeUser());
    dispatch(removeCsrUser());
    setAgentData({
      agentPolicies: [],
      filteredPolicies: [],
      agentClaims: [],
    });
    const esb = window?.embeddedservice_bootstrap;
    if (!esb?.userVerificationAPI || !esb?.utilAPI) {
      // embeddedservice_bootstrap not loaded or not available in this context
      return;
    }
    try {
      esb.userVerificationAPI
        .clearSession(true)
        .then(() => {
          esb.utilAPI.removeAllComponents();
        })
        .catch(() => {
          console.log("Error Clearing SFDC Componenets");
        });
    } catch {
      console.log("Error Clearing SFDC Componenets");
    }
  }, []);
  return (
    <>
      <div className="container mb-8">
        <h1>{t("UnAuthLandingPage-agentTitle")}</h1>
        <hr />
      </div>
      {bannerMessage && (
        <div className="container ui-component-spacing">
          <Billboard
            data={{
              title: <>{bannerTitle ?? t("Notice-title")}</>,
              svgClass: "text-ui-green",
              svgUse: "ui-icon-border-good",
              description: <Trans i18nKey={bannerMessage} />,
            }}
          />
        </div>
      )}

      <div className="container ui-component-spacing">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3 xl:gap-6">
          <LoginCard loginType={portal} setHideCustomChat={setHideCustomChat} />
          <AgentSignupCard />
          <GuestServicesCard
            setHideCustomChat={setHideCustomChat}
            connectingToSF={connectingToSF}
            setConnectingToSF={setConnectingToSF}
            openChatWindow={openChatWindow}
            setOpenChatWindow={setOpenChatWindow}
          />
        </div>
      </div>
    </>
  );
}
